import { TxCenterInfo } from '@/api/apis/customer';
import { OpoOrganizationMembership, UserProfileType } from '@/api/apis/user';
import { Organization, OrganizationType } from './organization.types';

export const toOrganizationFromTxCenter = (t: TxCenterInfo): Organization => ({
  id: t.txCenterId,
  name: t.txCenterName,
  code: t.txCenterCode ?? '',
  countryCode: t.txCenterCountryCode,
  roles: t.roles,
  permissions: t.permissions ?? [],
  isPrimary: t.isPrimary,
  type: OrganizationType.TxCenter,
  trialPrograms: t.txCenterTrialPrograms,
});

export const toOrganizationFromOpo = (o: OpoOrganizationMembership): Organization => ({
  id: o.organizationId,
  name: o.organizationName,
  code: o.organizationCode,
  countryCode: o.organizationCountryCode,
  roles: o.roles,
  permissions: o.permissions,
  isPrimary: o.isPrimary,
  type: OrganizationType.OPO,
});

export const getOrganizationsFromProfile = (profile: UserProfileType): Organization[] => {
  const txCenterOrgs = (profile.customer?.customerInTxCenters ?? []).map(toOrganizationFromTxCenter);
  const opoOrgs = (profile.opoContact?.opoUserInOpoOrganizations ?? []).map(toOrganizationFromOpo);
  return [...txCenterOrgs, ...opoOrgs];
};
